// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5 3h-9A4.5 4.5 0 003 7.5v9A4.5 4.5 0 007.5 21h9a4.5 4.5 0 004.5-4.5v-9A4.5 4.5 0 0016.5 3zm-1.286 10.286H8.786a1.285 1.285 0 110-2.572h6.428a1.285 1.285 0 110 2.572z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;